import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Add Designation Service*/
const salaryReport = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.reports.salaryReport}`,
    method: "POST",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


export default {
  salaryReport,
}